import type {
  ArraySchema,
  BooleanSchema,
  DateSchema,
  NumberSchema,
  ObjectSchema,
  StringSchema,
  ValidationError,
} from 'yup';
import type {Maybe} from '../../../graphql';

export type JSONValue =
  | string
  | number
  | boolean
  | null
  | JSONObject
  | Array<JSONValue>;

export interface JSONObject {
  [x: string]: JSONValue;
}

export interface ICommonFieldProps {
  tag: string;
  required?: boolean;
  schema?: allSchemas;
}

export type allSchemas =
  | BooleanSchema
  | StringSchema<any>
  | ObjectSchema<any>
  | ArraySchema<any>
  | DateSchema<any>
  | NumberSchema<any>;

export type StateType = {
  [x: string]: JSONValue | undefined;
};
export type ErrorType = Record<string, FakeError>;

export type FakeError = {
  internals: Record<string, FakeError> | undefined;
  self: ValidationError | undefined;
};

export interface IWrapperProvider {
  translationPrefix: string;
  state: StateType;
  errors: FakeError | undefined;
  disabled: boolean;
  genericHandler: (
    tag: string,
    value: JSONValue | Record<string, JSONValue>,
  ) => void;
  getLabel: (
    tag: string,
    required?: boolean | undefined,
    label?: Maybe<string>,
  ) => string;
  showErrors: boolean | 'invalid';
  registerField: (
    tag: string,
    fieldSchema: allSchemas | undefined,
    remove: boolean,
    initial: any,
  ) => void;
}

export type WrapperHandler<T = StateType> = (
  state: T,
  errors?: ErrorType,
) => void;

export type preValidationTransform = (mergeState: StateType) => any;

/// type guards
export function isValidError(
  err: unknown | (FakeError | ValidationError),
): err is FakeError | ValidationError {
  return (
    `internals` in (err as FakeError) ||
    `self` in (err as FakeError) ||
    !!(err as ValidationError).inner
  );
}

export function fakeOrValidation(
  err: FakeError | ValidationError,
): err is FakeError {
  return !(err as ValidationError).inner;
}
